import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=53ff03f8"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports